<template>
    <div role="group" class="form-group page-type-group">
        <h3 v-if="!noTitle">{{ label }}</h3>
        <p>{{ description }}</p>
        <div v-for="option in options" :key="option.id" :class="['checkbox-detailed', disabled ? 'disabled' : '']">
            <img class="template-img" v-if="option.image" :src="option.image" />
            <input v-model="currentValue"
                type="checkbox"
                :name="getInputKey(0)"
                :value="option.id"
                :id="getInputKey(option)"
                :class="[disabled ? 'disabled' : '']">
            <label :for="getInputKey(option)" :class="[option.image ? 'checkbox-has-image' : '']">
                <span class="checkbox-detailed-tbl">
                    <span class="checkbox-detailed-cell">
                        <div v-if="option.name" class="col-form-label template-label">{{ __(option.name, ['titleCase']) }}</div>
                        {{ option.description }}
                        <!-- *** DATMAN ** can you add this only for Content panel only - see Scott -->
                        <!-- <button class="icon-delete">Delete panel</button> -->
                    </span>
                </span>
            </label>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            randomKey: Math.floor(Math.random() * 1000000),
            currentValue: this.value,
        }
    },

    props: ['value', 'label', 'required', 'disabled', 'data', 'config', 'error'],

    watch: {
        currentValue(newVal) {
            this.$emit('input', newVal);
        }
    },

    computed: {
        options() {
            return _.get(this.config, 'values', []);
        },

        description() {
            return _.get(this.config, 'description', '');
        },

        defaultValue() {
            return _.get(this.config, 'default');
        },

        noTitle() {
            return _.get(this.config, 'noTitle');
        },
    },

    methods: {
        getInputKey(value) {
            return `checkbox-${this.randomKey}-${value.id}`;
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/CheckboxListComponent.vue